export default "__VITE_ASSET__b49c8408__"